import * as React from "react";
const IconBookSession = (props) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3411_9172)">
      <path
        d="M1.82959 11.8946H1.17959V13.1946H1.82959V11.8946ZM20.3521 13.1946H21.0021V11.8946H20.3521V13.1946ZM8.31245 19.3036C7.95347 19.3036 7.66245 19.5946 7.66245 19.9536C7.66245 20.3125 7.95347 20.6036 8.31245 20.6036V19.3036ZM13.8692 20.6036C14.2282 20.6036 14.5192 20.3125 14.5192 19.9536C14.5192 19.5946 14.2282 19.3036 13.8692 19.3036V20.6036ZM11.7408 16.2491C11.7408 15.8901 11.4498 15.5991 11.0908 15.5991C10.7318 15.5991 10.4408 15.8901 10.4408 16.2491H11.7408ZM4.60796 2.08109H17.5737V0.781091H4.60796V2.08109ZM19.7021 4.20946V13.4707H21.0021V4.20946H19.7021ZM17.5737 15.5991H4.60796V16.8991H17.5737V15.5991ZM2.47959 13.4707V4.20946H1.17959V13.4707H2.47959ZM4.60796 15.5991C3.43249 15.5991 2.47959 14.6462 2.47959 13.4707H1.17959C1.17959 15.3641 2.71452 16.8991 4.60796 16.8991V15.5991ZM19.7021 13.4707C19.7021 14.6462 18.7491 15.5991 17.5737 15.5991V16.8991C19.4671 16.8991 21.0021 15.3641 21.0021 13.4707H19.7021ZM17.5737 2.08109C18.7491 2.08109 19.7021 3.03399 19.7021 4.20946H21.0021C21.0021 2.31602 19.4671 0.781091 17.5737 0.781091V2.08109ZM4.60796 0.781091C2.71452 0.781091 1.17959 2.31602 1.17959 4.20946H2.47959C2.47959 3.03399 3.43249 2.08109 4.60796 2.08109V0.781091ZM1.82959 13.1946H20.3521V11.8946H1.82959V13.1946ZM8.31245 20.6036H11.0908V19.3036H8.31245V20.6036ZM11.0908 20.6036H13.8692V19.3036H11.0908V20.6036ZM11.7408 19.9536V16.2491H10.4408V19.9536H11.7408Z"
        fill="#1C1C2C"
      />
    </g>
    <defs>
      <clipPath id="clip0_3411_9172">
        <rect width={21} height={21} fill="white" transform="translate(0.59082 0.192322)" />
      </clipPath>
    </defs>
  </svg>
);
export default IconBookSession;
